import {UIGameTradeOfferedCardSelectorView} from './UIGameTradeOfferedCardSelectorView'
import {UIGameTradeWantedCardSelectorView} from './UIGameTradeWantedCardSelectorView'

export class UIGameTradeAnyCardDisplayController {
    isAnyCardDisplayEnabled: boolean = false
    private isAnyCardPermanentlyDisabled: boolean = false

    private wantedCardSelectorView: UIGameTradeWantedCardSelectorView
    private offeredCardSelectorView: UIGameTradeOfferedCardSelectorView

    constructor(wantedCardSelectorView: UIGameTradeWantedCardSelectorView, offeredCardSelectorView: UIGameTradeOfferedCardSelectorView) {
        this.setCardSelectorViews(wantedCardSelectorView, offeredCardSelectorView)
    }

    setCardSelectorViews(wantedCardSelectorView: UIGameTradeWantedCardSelectorView, offeredCardSelectorView: UIGameTradeOfferedCardSelectorView) {
        this.wantedCardSelectorView = wantedCardSelectorView
        this.offeredCardSelectorView = offeredCardSelectorView
    }

    updateAndResetCards(inBankTradeMode: boolean, inCounterOffer: boolean, doesPlayerHaveCards: boolean) {
        this.isAnyCardDisplayEnabled = this.shouldDisplayAnyCard(inBankTradeMode, inCounterOffer, doesPlayerHaveCards)
        this.wantedCardSelectorView.resetCards(this.isAnyCardDisplayEnabled)
        this.offeredCardSelectorView.resetCards(this.isAnyCardDisplayEnabled)
    }

    private shouldDisplayAnyCard(inBankTradeMode: boolean, inCounterOffer: boolean, cardsEmpty: boolean) {
        if(cardsEmpty) return false
        if(this.isAnyCardPermanentlyDisabled) return false
        if(inBankTradeMode) return false
        return true
    }

    permanentlyDisableAnyCard() {
        this.isAnyCardPermanentlyDisabled = true
    }
}
